import { isEmpty } from '@/common/helpers';

export default {
    props: {
        value: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            localFilters: {},
            isFormDirty: false,
            isFormValid: false
        };
    },
    computed: {
        showFilterDrawer: {
            get() {
                return this.value;
            },
            set(newValue) {
                if (newValue) {
                    this.localFilters = Object.assign({}, this.filters);
                }
                this.$emit('input', newValue);
            }
        },
        isFiltersEmpty() {
            return (
                Object.values(this.localFilters).findIndex(item =>
                    this.haveValue(item)
                ) === -1
            );
        },
        filtersDesc() {
            return this.schema
                .filter(item => this.haveValue(this.localFilters[item.name]))
                .map(item => {
                    let filterLabel = item.name;
                    if (item && item.label) {
                        filterLabel = item.label;
                    } else if (
                        item &&
                        item.component &&
                        item.component.props &&
                        item.component.props.label
                    ) {
                        filterLabel = item.component.props.label;
                    }
                    return {
                        name: item.name,
                        text: filterLabel,
                        value: this.localFilters[item.name]
                    };
                });
        }
    },
    methods: {
        // ================ Events ==================
        onCancelFilters() {
            this.clearFilters();
        },
        onApplyFilters() {
            this.isFormDirty = false;
            this.applyFilters();
            this.clearFilters();
        },
        onClearFilters() {
            this.isFormDirty = false;
            this.clearFilters();
            this.applyFilters();
        },
        // =============== Others ==================
        applyFilters() {
            // need to return the localFields values
            const newFilters = this.nonEmptyValues(this.localFilters);
            this.$emit('apply', {
                filters: newFilters,
                filtersDesc: this.filtersDesc
            });
        },
        clearFilters() {
            this.localFilters = {};
        },
        resetFilters() {
            this.localFilters = Object.assign({}, this.filters);
        },
        haveValue(value) {
            return (
                !isEmpty(value) ||
                typeof value === 'number' ||
                typeof value === 'boolean'
            );
        },
        nonEmptyValues(source) {
            const result = {};
            Object.keys(source).forEach(key => {
                if (this.haveValue(source[key])) {
                    result[key] = source[key];
                }
            });
            return result;
        }
    }
};
